

import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Box,
  Typography,
  TextField,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
  Chip,
  InputAdornment,
} from '@mui/material';
import {
  Search as SearchIcon,
  Receipt as ReceiptIcon,
  EventBusy as EventBusyIcon,
  Event as EventIcon,
  List as ListIcon,
} from '@mui/icons-material';
import { useStateValue } from '../../contexto/store';
import HttpCliente from '../../service/HttpCliente';
import TFacturas from './TFacturas';
import { useHistory } from 'react-router-dom';
import { obtenerListaUsuarios } from '../../actions/UsuariosAction';
import { useRef } from 'react';
export default function FacturasGeneral() {
  const [{ sesionUsuario }] = useStateValue();
  const [term, setTerm] = useState('');
  const [radioValor, setRadioValor] = useState('Todas');
  const [datosCargados, setDatosCargados] = useState(false);
  const [facturas, setFacturas] = useState([]);
  const [dataUsuarios, setDataUsuarios] = useState([]);
  const history = useHistory();
  const mounted = useRef(true); 
  const radioValorHandleChange = (event) => {
    setRadioValor(event.target.value);
  };

  //  Llamadas a los endpoints
  const obtenerFacturasGeneral = async () => HttpCliente.get('/COBRANZAS/obtenerFacturas');
const obtenerFacturasVencidas = async () =>
  HttpCliente.get('/COBRANZAS/facturasVencidas');

const obtenerFacturasAVencer = async () =>
  HttpCliente.get('/COBRANZAS/facturasAVencer');

const cargarFacturas = async () => {
  setDatosCargados(false);

  try {
    let response;

    switch (radioValor) {
      case 'Todas':
        response = await obtenerFacturasGeneral();
        break;

      case 'Vencidas':
        response = await obtenerFacturasVencidas();
        break;

      case 'AVencer':
        response = await obtenerFacturasAVencer();
        break;

      default:
        response = await obtenerFacturasGeneral();
    }

    const facturasData = Array.isArray(response.data) ? response.data : [];

    const facturasOrdenadas = [...facturasData].sort((a, b) => {
      if (!a.tieneTareas && b.tieneTareas) return -1;
      if (a.tieneTareas && !b.tieneTareas) return 1;
      return 0;
    });

    setFacturas(facturasOrdenadas);
  } catch (err) {
    console.error('Error cargando facturas', err);
    setFacturas([]);
  } finally {
    setDatosCargados(true);
  }
};
  useEffect(() => {
    if (mounted.current) {
      obtenerListaUsuarios().then((response) => {
        if (response.status === 200) {
          setDataUsuarios(response.data);
        } else {
          console.log('No se pudo obtener lista de usuarios');
        }
      });
    }
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    cargarFacturas();
    // eslint-disable-next-line
  }, [radioValor]);


   const seleccionarFacturas = (facturas) => {
    /*RRR:FACTURAS/TAREA-01 enviamos la solicitud de tarea nueva con un estado donde pasamos
    las facturas a las que queremos crearle una tarea y una variable para que le componente 
    reconozca que se trata de una tarea que tiene facturas */
    facturas['facturas'] = true;
    history.push({ pathname: '/nuevaTarea', state: {facturas, origen: 'panelFacturasGeneral',DataUsu: dataUsuarios,}, });
  };
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          color: 'white',
          p: 3,
          mb: 3,
          borderRadius: 2,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -20,
            right: -20,
            opacity: 0.2,
            transform: 'rotate(-15deg)',
          }}
        >
          <ReceiptIcon sx={{ fontSize: 120 }} />
        </Box>
        <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <ReceiptIcon sx={{ fontSize: 40 }} />
          <Box sx={{ flex: 1 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
              Panel General de Facturas
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Gestión y seguimiento de todas las facturas
            </Typography>
          </Box>
          <Chip
            label={`${facturas.length} facturas`}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              fontWeight: 600,
              fontSize: '0.9rem',
            }}
          />
        </Box>
      </Paper>

      {/* Barra de búsqueda */}
      <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar por cliente, nro. comprobante..."
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        />
      </Paper>

      {/* Filtros con RadioGroup */}
      <Paper elevation={1} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
          Filtrar por Estado
        </Typography>
        <RadioGroup
          row
          value={radioValor}
          onChange={radioValorHandleChange}
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <FormControlLabel
            value="Todas"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ListIcon sx={{ fontSize: 20, color: 'primary.main' }} />
                <Typography>Todas</Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="Vencidas"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EventBusyIcon sx={{ fontSize: 20, color: 'error.main' }} />
                <Typography>Vencidas</Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="AVencer"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EventIcon sx={{ fontSize: 20, color: 'warning.main' }} />
                <Typography>A Vencer</Typography>
              </Box>
            }
          />
        </RadioGroup>
      </Paper>

      {/* Tabla de Facturas */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {datosCargados ? (
          <TFacturas
            rows={facturas || []}
            termf={term}
            seleccionarFacturas={seleccionarFacturas}
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} />
            <Typography variant="body1" color="text.secondary">
              Cargando facturas...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
}
